module.exports = __webpack_public_path__ + "static/img/back.6e422f34.png";